import React from "react";
import VisorPluginPlaceholder from "../../../_visor/components/canvas/VisorPluginPlaceholder";
import { letterFromNumber } from "../../../common/common_tools";
import { setRgbaAlpha } from "../../../common/common_tools";
import { correctArrayUnordered } from "../../../core/visor/correction_functions";
import i18n from "i18next";
import MultipleAnswerVisor from "../MultipleAnswerVisor";

export function MultipleAnswer() {
  return {
    getRenderTemplate: function (state, props) {
      return <MultipleAnswerVisor state={state} props={props} />;
    },
    checkAnswer(current, correct, state) {
      return correctArrayUnordered(current, correct, state?.allowPartialScore, state?.nBoxes);
    },
  };
}
